export default function ManagerIcon({ color, strokeColor = "white" }: { color?: string; strokeColor?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="36"
      viewBox="0 0 44 36"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.4003 20.02C31.8792 21.0051 36.4833 24.6241 36.4833 30.2263C36.4833 30.9865 36.1808 31.7136 35.6443 32.2514C35.1079 32.7891 34.3795 33.0903 33.6193 33.0903H10.364C9.60385 33.0903 8.87672 32.7891 8.33898 32.2514C7.80255 31.7149 7.5 30.9865 7.5 30.2263C7.5 24.6241 12.1054 21.0138 17.5817 20.02C20.433 19.5026 23.5489 19.5064 26.4003 20.02ZM21.9918 3.09033C26.1881 3.09033 29.5947 6.49722 29.5947 10.6933C29.5947 14.8893 26.1878 18.2962 21.9918 18.2962C17.7957 18.2962 14.3888 14.8893 14.3888 10.6933C14.3888 6.49722 17.7957 3.09033 21.9918 3.09033Z"
        fill={color || "#1934EF"}
        stroke={strokeColor}
        strokeWidth={strokeColor === "white" ? "0" : "1.5"}
      />
    </svg>
  );
}
